export function loadJsOnUserInteraction(callback) {
  let loadingContent = false;
  const realUserLoadContent = function () {
    if (!loadingContent) {
      loadingContent = true;
      window.removeEventListener("scroll", realUserLoadContent);
      document.removeEventListener("mousemove", realUserLoadContent);
      document.removeEventListener("touchmove", realUserLoadContent);

      callback();
    }
  }

  let realUserLoadMainPicTrigger = function () {
    window.addEventListener("scroll", realUserLoadContent),
      document.addEventListener("mousemove", realUserLoadContent),
      document.addEventListener("touchmove", realUserLoadContent);

    // Fallback: Load after 4 seconds if no user interaction
    setTimeout(realUserLoadContent, 4000);
  };

  if (-1 === window.navigator.userAgent.toLowerCase().indexOf("lighthouse") && null === document.querySelector(".honeypot")) {
    realUserLoadMainPicTrigger()
  } else {
    // Immediate load for lighthouse or bots
    // callback();
  }
}